export default createMixin("loading", "tryLoad");

export const TrySaveMixin = createMixin("saving", "trySave");

export function createMixin(variableName, methodName) {
    console.assert(variableName && methodName);
    return {
        data: () => ({
            [variableName]: false
        }),
        methods: {
            // Permet de définir une variable de 'loading' et lui affecter l'état de chargement en cours de la callback passé en paramètre

            async [methodName](callback, catchCallback = undefined) {
                console.assert(!this[variableName], `[${variableName}] locked but attempted to start an action that changes it again`);
                try {
                    this[variableName] = true;
                    return await callback();
                } catch (e) {
                    const defaultBehavior = () => this.dialogError(e);
                    if (!catchCallback) {
                        defaultBehavior(e);
                    } else {
                        catchCallback(e, defaultBehavior);
                    }
                    throw e;
                } finally {
                    this[variableName] = false;
                }
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/mixins/TryLoadMixin.js